export enum TipoPeriodoTelemetry {
    TOTAL = "total",
    DIA = "dia",
    SEMANA = "semana",
    MES = "mes",
}

export enum TipoBusquedaTelemetry {
    CON_RESULTADOS = "con_resultados",
    SIN_RESULTADOS = "sin_resultados"
}

export interface ResultTelemetry {
    total: number;
}

export interface BusquedaResultadoTelemetry {
    texto_busqueda: string;
    frecuencia: number;
}
export interface TelemetryRowObject {
    id_article: number;
    articulo_categoria: string;
    title: string;
    image: string;
    isbn?: string;
    author: string;
    num_favoritos?: number;
    visto?: number;
}

export interface ObtenerVisitasTelemetria {
    texto: string;
    visitas: number;
}

export enum TipoSeccionLibrosEstadisticas {
    LIBROS_POPULARES = "libros_populares",
    LIBROS_PROPIOS_POPULARES = "libros_propios_populares",
    AUTORES_POPULARES = "autores_populares",
    EDITORIALES_POPULARES = "editoriales_populares",
    LIBROS_MAS_VENIDOS = "libros_mas_vendidos",
    LIBROS_MAS_VISITADOS = "libros_mas_visitados",
    LIBROS_MAS_CONTACTADOS = "libros_mas_contactados",
    LIBROS_MAS_FAVORITOS = "libros_mas_favoritos",
    LIBROS_MAS_FAVORITOS_PROPIOS = "libros_mas_favoritos_propios",
    BUSQUEDAS_CON_RESULTADOS = "busquedas_con_resultados",
    BUSQUEDAS_SIN_RESULTADOS = "busquedas_sin_resultados"
}
